module.exports = __webpack_public_path__ + "img/_search-movil.dccebc3f.svg";